
    import './styles.scoped.css';
    export default {
  "drawer-displayed": "awsui_drawer-displayed_1lh3u_16xqy_149",
  "drawer-content": "awsui_drawer-content_1lh3u_16xqy_153"
};
  